import { trans } from "@mongez/localization";
import { type Badge as BadgeType, ShopProduct } from "core/catalog";
import { cn } from "~/shared/lib";

type BadgeProps = {
  product: ShopProduct;
  classes?: {
    container?: string;
    badge?: string;
  };
};

const badgeStyles = {
  custom: "bg-white text-red-400 border border-red-400",
  new: "bg-primary-default text-white",
  "low-stock": "bg-primary-default text-white",
  featured: "bg-primary-default text-white",
  "out-of-stock": "text-white bg-red-400",
};

export function Badge({ product, classes }: BadgeProps) {
  const { badge, discount } = product;
  const badges: BadgeType[] = [];

  if (!product.inStock) {
    badges.push({
      type: "out-of-stock",
      label: trans("outOfStock"),
    });
  }

  if (badge?.label && badge.label !== trans("outOfStock")) {
    badges.push({
      type: badge.type,
      label: badge.label,
    });
  }

  if (discount?.percentage) {
    badges.push({
      type: "custom",
      label: `${discount.percentage}%`,
    });
  }

  if (!badges.length) return null;

  return (
    <div
      className={cn(
        "absolute top-6 z-10 flex flex-col gap-2 rounded-full ltr:left-6 rtl:right-6",
        classes?.container,
      )}
    >
      {badges.map((badge, index) => (
        <span
          key={index}
          className={cn(
            "rounded-full border border-transparent px-3 py-1 text-center text-xs font-semibold",
            badgeStyles[badge.type] || "bg-primary text-white",
            classes?.badge,
          )}
        >
          {badge.label}
        </span>
      ))}
    </div>
  );
}
